import React from 'react';
import ReactDOM from 'react-dom';
import './style/index.css';
import './style/esqueceu-senha.css';
import './style/dashboard.css';
import './style/grid.css';
import './style/home.css';
import './style/usuarios.css';
import './style/centros.css';
import './style/estoque.css';
import './style/contas.css';
import './style/movimentacoes.css';
import './style/relatorios.css';
import App from './App.jsx';

ReactDOM.render(<App />, document.getElementById("root"));

